import axios from 'axios';

export default {
  getOfficeIp({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/officeIp/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertOfficeIp', resp.data?.data?.ip);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateOfficeIp({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/officeIp/update`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('updateOfficeIpRequestSuccess', resp.data?.data?.ip);
          resolve(resp);
        })
        .catch(err => {
          commit('updateOfficeIpRequestError', err.message);
          reject(err);
        });
    });
  }
};
